export default {
    props: {
        lng: {
            default () {
                return '116.54611555876909';
            }
        },
        lat: {
            default () {
                return '40.26940227400542';
            }
        },
        zoom: {
            type: Number,
            default () {
                return 9;
            }
        },
        scale: {
            default () {
                return 1;
            }
        },
        showMap: {
            type: Boolean,
            default: false
        }
    }
}